import { Dispatch, SetStateAction } from 'react'
import { API_ERROR_MESSAGE } from '../../utils/Constants'
import { downloadImage } from '../../utils/utils'
import { API_CALL_TYPE, getAPIUrl } from '../API'
import { ProductIds } from '../apiConstants'
import { makeApiCall } from '../APIService'
import { DownloadFaceViewReport } from '../faceView/faceView'
import { onDownloadSuccess } from '../shared/downloadFile'
import { DownloadRealtimeReport } from '../realTimeIDV/realTimeIdv'
interface Report {
  reference: string
  name: string
  reportType: string
  requestedAt: string
  id: string
  reportTypeDescription: string
  reportTypeId: number
  reportIdNumber: string
  isActive: boolean
}
interface getUserReportsProps {
  setShowProgress: Dispatch<SetStateAction<boolean>>
  setIsError: Dispatch<SetStateAction<boolean>>
  setErrorMessage: Dispatch<SetStateAction<string>>
  setData: Dispatch<SetStateAction<Report[]>>
  setCurrentRecords: Dispatch<SetStateAction<Report[]>>
  setNpages: Dispatch<SetStateAction<number>>
  recordsPerPage: number
  indexOfFirstRecord: number
  indexOfLastRecord: number
}

export const getUserReports = (props: getUserReportsProps): void => {
  const {
    setShowProgress,
    setIsError,
    setErrorMessage,
    setData,
    setCurrentRecords,
    setNpages,
    recordsPerPage,
    indexOfFirstRecord,
    indexOfLastRecord,
  } = props
  const API_URL: string = getAPIUrl() + '/User/user-reports'
  setShowProgress(true)
  setIsError(false)
  setErrorMessage('')

  makeApiCall(
    API_CALL_TYPE.GET_CALL,
    API_URL,
    (response: { statusCode: number; data: any[] }) => {
      if (response.statusCode !== 200) {
        setIsError(true)
        setErrorMessage(API_ERROR_MESSAGE)
      } else {
        setShowProgress(false)
        const reports: Report[] | ((prevState: Report[]) => Report[]) = []
        response.data.forEach((report: any) => {
          reports.push(report)
        })
        setData(reports)
        setCurrentRecords(reports)
        // setNpages(Math.ceil(reports.length / recordsPerPage))
      }
    },
    (error: any) => {
      console.log(error)
      setShowProgress(false)
      setIsError(true)
      setErrorMessage(API_ERROR_MESSAGE)
    },
    {},
    {
      Authorization: 'Bearer ' + sessionStorage.getItem('jwt'),
    },
    null,
    false,
  )
}

interface downloadUserReportProps {
  report: Report
  setShowProgress: Dispatch<SetStateAction<boolean>>
  setIsError: Dispatch<SetStateAction<boolean>>
  setErrorMessage: Dispatch<SetStateAction<string>>
}
export const downloadUserReport = (props: downloadUserReportProps): void => {
  const { report, setShowProgress, setIsError, setErrorMessage } = props
  const requestOptions: RequestInit = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + sessionStorage.getItem('jwt'),
    },
    body: JSON.stringify({
      reportId: report.id,
      reportType: report.reportTypeId,
    }),
  }
  setShowProgress(true)
  setIsError(false)
  setErrorMessage('')
  let API_URL: string = getAPIUrl()

  if (report.reportType === 'RealTimeIDVReport') {
    const downloadBody = {
      reportType: report.reportTypeId,
      reportId: report.id,
    }
    DownloadRealtimeReport({ body: downloadBody })
      .then((downloadResponse) => {
        if (downloadResponse) {
          setShowProgress(false)
          onDownloadSuccess(downloadResponse)
        }
      })
      .catch((error) => {
        setShowProgress(false)
        setIsError(true)
        setErrorMessage(API_ERROR_MESSAGE)
      })
    return
  } else if (report.reportType === 'FaceViewReport') {
    const downloadBody = {
      reportType: report.reportTypeId,
      reportId: report.id,
    }
    DownloadFaceViewReport({ body: downloadBody })
      .then((downloadResponse) => {
        if (downloadResponse) {
          setShowProgress(false)
          onDownloadSuccess(downloadResponse)
        }
      })
      .catch((error) => {
        setShowProgress(false)
        setIsError(true)
        setErrorMessage(API_ERROR_MESSAGE)
      })
    return
  } else {
    switch (report.reportType) {
      case 'CreditEnquiryReport':
        API_URL += '/CreditEnquiry/download-report'
        break

      case 'CIPCBusinessReport':
        API_URL += '/BusinessEnquiry/download-report'
        break

      case 'DetailedBusinessReport':
        API_URL += '/BusinessEnquiry/download-report'
        break
      case 'CIPCDirectorEnquiryReport':
        API_URL += '/DirectorEnquiry/download-report'
        break

      case 'SanctionScreeningReport':
        API_URL += '/SanctionScreening/download-report'
        break
      case 'WorldComplianceReport':
        API_URL += '/WorldCompliance/download-report'
        break

      default:
        break
    }
  }

  fetch(API_URL, requestOptions)
    .then((res) => {
      return res.blob()
    })
    .then((blob) => {
      setShowProgress(false)
      const href: string = window.URL.createObjectURL(blob)
      const link: HTMLAnchorElement = document.createElement('a')
      link.href = href
      link.setAttribute('download', 'report.pdf')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    })
    .catch((error: any) => {
      setShowProgress(false)
      setIsError(true)
      setErrorMessage(API_ERROR_MESSAGE)
      return Promise.reject({ Error: 'Something Went Wrong', error })
    })
}
